import { DadosLogarType } from "../types";

export function mapperDadosLogar(data: string): DadosLogarType {
  const dadosObj = data
    .trim()
    .split(";")
    .reduce(
      (a, c, i) => ({
        ...a,
        [["idUsuario", "idGrupo", "idRetorno", "descRetorno"][i]]: c,
      }),
      {}
    );

  return dadosObj as DadosLogarType;
}
